var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { flatArrays } from 'src/shared/helpers/objHelpers';
import { E_FILE_TYPE } from 'src/redux/core/types';
// Preparing files meaning we are going to fetch them, so we can set isLoading at true
export var prepareDocumentAndControlsFiles = function (files, priority, isHighestPriority) {
    return (files || []).reduce(function (acc, file, index) {
        var _a;
        if (!(file === null || file === void 0 ? void 0 : file.url)) {
            return acc;
        }
        return __assign(__assign({}, acc), (_a = {}, _a[file.url] = {
            url: file.url,
            name: file.name,
            file: null,
            isLoading: true,
            isError: false,
            priority: isHighestPriority && index === 0 ? priority + 1 : priority,
            headers: null,
            type: E_FILE_TYPE.UNKNOWN,
            fileUpdated: null,
        }, _a));
    }, {});
};
export var extractFilesUrlsToCaseDetails = function (caseDetails) {
    var allStudyElements = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.studyElements;
    if (!(allStudyElements === null || allStudyElements === void 0 ? void 0 : allStudyElements.length)) {
        return {};
    }
    var highestStudyNumber = Math.max.apply(Math, allStudyElements.map(function (doc) { var _a; return (_a = doc.studyNumber) !== null && _a !== void 0 ? _a : 0; }));
    var highestPriorityIndex = allStudyElements.findIndex(function (d) { var _a; return ((_a = d.studyNumber) !== null && _a !== void 0 ? _a : 0) === highestStudyNumber; });
    var allEntries = allStudyElements.flatMap(function (doc, index) {
        var isHighestPriority = index === highestPriorityIndex;
        var docFilesUrls = prepareDocumentAndControlsFiles(doc.files, doc.studyNumber, isHighestPriority);
        return Object.entries(docFilesUrls);
    });
    return allEntries.reduce(function (acc, _a) {
        var _b;
        var _c, _d;
        var url = _a[0], fileObj = _a[1];
        var existing = acc[url];
        if (existing) {
            var existingPriority = (_c = existing.priority) !== null && _c !== void 0 ? _c : 0;
            var newPriority = (_d = fileObj.priority) !== null && _d !== void 0 ? _d : 0;
            if (existingPriority >= newPriority) {
                return acc;
            }
        }
        return __assign(__assign({}, acc), (_b = {}, _b[url] = fileObj, _b));
    }, {});
};
export var extractFilesUrlsToDownloadContractCase = function (contractsBundle) {
    var allContracts = flatArrays((contractsBundle || []).map(function (bundle) { return bundle.contracts; }));
    return allContracts.reduce(function (acc, contract) {
        var _a;
        if (!(contract === null || contract === void 0 ? void 0 : contract.fileUrl)) {
            return acc;
        }
        return __assign(__assign({}, acc), (_a = {}, _a[contract.fileUrl] = {
            file: null,
            isLoading: true,
            isError: false,
            headers: null,
            type: E_FILE_TYPE.UNKNOWN,
            fileUpdated: null,
        }, _a));
    }, {});
};
